// Valitions Errors
export const ERROR_EMAIL = 'Please enter a valid email address.';
export const ERROR_UNSUPPORTED_EMAIL = 'A professional email address is required.';
export const ERROR_REQUIRED = 'Required field.';
export const ERROR_MINLENGTH = 'Minimum 8 characters required';
export const ERROR_CONFIRM_PASS = 'Passwords do not match';
export const ERROR_NUMBER = 'Not a valid number.';
export const ERROR_ANPHANUMERIC = 'Please enter valid alphanumeric characters.';
export const ERROR_DATE = 'Please enter a valid date.';
export const ERROR_MOBILE = 'Invalid phone number.';
export const ERROR_INVALID_VALUE = 'Please enter a valid value.';
export const ERROR_INVALID_NAME = `Please remove the " or '`;
export const ERROR_NETWORK_CONNECTION = 'ERROR_NETWORK_CONNECTION';
export const ERROR_BALANCE_IS_NOT_AVAILABLE = 'Insufficient balance.';
export const ERROR_BENEFICIARY_IS_NOT_EXISTS = 'Beneficiary does not exist.';
export const ERROR_BENEFICIARY_EXISTS = 'Beneficiary name already exists.';
export const ERROR_BENEFICIARY_CODE = 'Account number already exists.';
export const ERROR_PASSWORD_CORRECT = 'Current password is incorrect.';
export const ERROR_PASSWORD_NOT_UNIQUE = 'New password cannot be the same as current password';
export const ERROR_PASSWORD_INFO = (
    <>
        Password requirements:
        <ul>
            <li>Minimum length: 8</li>
            <li>Require number</li>
            <li>Require special character</li>
            <li>Require uppercase letter</li>
            <li>Require lowercase letter</li>
        </ul>
    </>
);
export const ERROR_PAYMENT_NOT_SUPPORTED = 'This payment route is not supported at this stage.';

export const ERROR_PASSWORD = 'Please enter a valid password.';

export const SUCCESS_RESET_PASSWORD = 'Password changed.';
export const FORGOT_SENT_ACTIVE_CODE = 'Verification code sent. Please check your inbox.';
export const ERROR_FORGOT_PASSWORD = 'Email does not exist. Please try again';
export const ERROR_CHANGE_PASSWORD = 'Change password failed';

// User Signup
export const SUCCESS_USER_SIGNUP = 'Your account has been created. Please check your email for verification.';
export const ERROR_USER_SIGNUP = 'Sign up failed. Please try again later.';
export const SUCCESS_UPDATE_USER = 'Your personal information has been updated.';
export const ERROR_UPDATE_USER = 'An error occurred while updating your personal information. Please try again later.';

export const SUCCESS_UPDATE_COMPANY = 'Your business information has been updated.';
export const ERROR_UPDATE_COMPANY =
    'An error occurred while updating your business information. Please try again later.';

export const SUCCESS_ACTIVATE_ACCOUNT =
    'Thank you for verifying your email address. You will be redirected to the Sign In page in a few seconds...';
export const SUCCESS_ACTIVATE_ACCOUNT_FEDERATED =
    'Thank you for verifying your email address. You will be redirected to Paytron in a few seconds...';
export const SUCCESS_RESEND_CODE = 'Verification code sent. Please check your inbox.';

export const MESSAGE_PROCESSING_REVIEW_ACCOUNT = 'Your account is under review. Please come back later.';
export const SUCCESS_SUBMIT_REVIEW_ACCOUNT =
    'Thank you for registering. Our team will review your details and process your account shortly!';

export const SUCCESS_CREATE_PAYMENT_METHOD = 'The new credit card added!';
export const ERROR_CREATE_PAYMENT_METHOD = 'Add the credit card failed!';

export const SUCCESS_DELETE_PAYMENT_METHOD = 'Delete the payment is successfully.';
export const ERROR_DELETE_PAYMENT_METHOD = 'Card deletion failed.';

export const SUCCESS_UPDATE_PAYMENT_METHOD = 'Update the payment is successfully.';
export const ERROR_UPDATE_PAYMENT_METHOD = 'Update the card failed.';

export const INFO_PASSWORD_RULE =
    'Minimum 8 characters required; At least 1 digit, 1 alphabet and 1 special character.';

export const ERROR_CHANGE_EMAIL = 'Email change failed.';
export const SUCCESS_CHANGE_EMAIL = 'Email changed successfully.';

export const SUCCESS_CREATE_BENEFICIARY = 'New beneficiary created.';
export const ERROR_CREATE_BENEFICIARY = 'New beneficiary creation failed.';

export const SUCCESS_UPDATE_BENEFICIARY = 'Beneficiary updated.';
export const ERROR_UPDATE_BENEFICIARY = 'Beneficiary update failed.';

export const SUCCESS_DELETE_BENEFICIARY = 'Archived beneficiary successfully.';
export const ERROR_DELETE_BENEFICIARY = 'Archive beneficiary failed.';
export const ERROR_DUPLICATE_BENEFICIARY =
    'This payment may be a duplicate of a previous one you made. You have already created a payment of {Amount} to {Beneficiary} on {Invoice date}.';

export const ERROR_DUPLICATE_BENEFICIARY_NO_BENEFICIARY =
    'This payment may be a duplicate of a previous one you made. You have already created a payment of {Amount} on {Invoice date}.';

export const SUCCESS_LINK_BANK_SEND_CODE =
    'We have deposited 1c to your account. Please enter the 6 digit verification code in the message associated with this deposit.';
export const ERROR_LINK_BANK_SEND_CODE = 'An error occurred while linkiing your bank account. Please try again.';
export const SUCCESS_LINK_BANK_ACCOUNT = 'Bank account successfully linked.';
export const ERROR_LINK_BANK_INVALID_CODE = 'Your verification code is incorrect. Please check again.';
export const ERROR_LINK_BANK_ACCOUNT = 'Your bank account link failed. Please try again.';

// Error payment page
export const SUCCESS_CREATE_PAYMENT = 'Payment submitted.';
export const ERROR_CREATE_PAYMENT = 'Error submitting payment.';

export const SUCCESS_UPDATE_PAYMENT = 'Payment updated.';
export const ERROR_UPDATE_PAYMENT = 'Payment update failed.';

export const SUCCESS_DELETE_PAYMENT = 'Payment deleted.';
export const ERROR_DELETE_PAYMENT = 'Payment deletion failed.';

export const SUCCESS_DELETED_PAYMENTS = 'Payments deleted.';
export const PARTIAL_SUCCESS_DELETED_PAYMENTS =
    'Not all payments were successfully deleted, please retry for the unsuccessfully deleted payments.';

export const ERROR_GET_BANK_FEES = 'Cannot retrieve payment fees';
export const ERROR_RATE_COULD_NOT_BE_RETRIEVED = 'Cannot retrieve rates';
export const ERROR_CONVERSION_LIMIT_AMOUNT = 'Minimum conversion amount is ';
export const ERROR_CONVERSION_RANGE_AMOUNT = 'Conversion range between :min and :max';
export const ERROR_CONVERSION_RANGE_MIN = 'Minimum :cur conversion is :min';
export const ERROR_CONVERSION_RANGE_MAX = 'Maximum :cur conversion is :max';

// --- End payment page

export const ERROR_AVATAR_FILE_TYPE =
    'The image you’ve uploaded is not compatible. The supported file types are: JPEG and PNG.';
export const ERROR_AVATAR_FILE_MAXIMUM = 'The image you’ve uploaded is too large. The maximum file size is 1mb.';

export const ERROR_BATCH_FILE_MAXIMUM =
    'The file you’ve uploaded is too large for batch upload. The maximum file size is 25mb.';
export const ERROR_BATCH_FILE_TYPE =
    'The file you’ve uploaded is not compatible with Batch Upload. Only ABA files (.aba) are currently supported.';
export const ERROR_BATCH_MANY_FILE = 'Batch payments only supports uploading one file at a time.';
export const ERROR_BATCH_MANY_FILE_HEADER = 'Too many files';

export const ERROR_INVOICE_FILE_TYPE =
    'The file you’ve uploaded is not compatible with Invoice Autopilot. The supported file types are: JPEG, PNG, and PDF.';
export const ERROR_INVOICE_FILE_MAXIMUM =
    'The file you’ve uploaded is too large for Invoice Autopilot. The maximum file size is 25mb.';
export const ERROR_INVOICE_MANY_FILE =
    'Invoice Autopilot only supports files that contain a single invoice. We’re working on this, but please split the invoice up for now.';
export const ERROR_UPDATE_INVOICE_AUTOPILOT = 'An error occurred while setting up Invoice Autopilot.';

export const ERROR_INVOICE_FILE_TYPE_HEADER = 'Unsupported file type';
export const ERROR_INVOICE_FILE_MAXIMUM_HEADER = 'File too large';
export const ERROR_INVOICE_MANY_FILE_HEADER = 'Too many invoices';

export const SUCCESS_CREATE_INVOICE =
    "Invoice processing. Once it's done, click 'review' to see the extracted information and proceed to payment.";
export const ERROR_CREATE_INVOICE = 'An error occurred while creating a new invoice.';
export const ERROR_UPLOAD_INVOICE = 'Invoice upload failed.';

export const SUCCESS_UPDATE_INVOICE = 'Invoice updated.';
export const ERROR_UPDATE_INVOICE = 'An error occurred while updating the invoice.';
export const ERROR_REVIEW_ITEM_INVOICE = 'Please choose invoice details.';

export const ERROR_CONVERSION_CURRENCY = 'The currencies are the same.';
export const SUCCESS_CREATE_CONVERSION_CURRENCY = 'Conversion successful.';
export const ERROR_CREATE_CONVERSION_CURRENCY = 'Conversion failed.';

// Funds - Withdraw page
export const SUCCESS_WITHDRAW_MONEY = 'Withdrawal successful. It should reflect in your account shortly.';
export const ERROR_WITHDRAW_MONEY = 'Withdrawal failed.';

// MFA
export const ERROR_ENABLE_MFA_SMS = 'Enabling SMS authentication failed. Please try again.';
export const ERROR_DISABLE_MFA_SMS = 'Disabling SMS authentication failed. Please try again.';
export const SUCCESS_SEND_CODE_MFA_SMS = 'The code sent successfully. Please check on your phone.';
export const ERROR_SEND_CODE_MFA_SMS = 'The code sent failed. Please try again.';
export const SUCCESS_ENABLE_MFA_SMS = 'Enabled SMS authentication successfully.';
export const SUCCESS_DISABLE_MFA_SMS = 'Disabled SMS authentication successfully.';
export const ERROR_INVALID_CODE_MFA_SMS = 'The code is invalid.';

export const ERROR_ENABLE_MFA_TOTP = 'Enable TOTP Authentication failed. Please try again.';
export const ERROR_DISABLE_MFA_TOTP = 'Disable TOTP Authentication failed. Please try again.';
export const SUCCESS_ENABLE_MFA_TOTP = 'Enabled TOTP Authentication successfully.';
export const SUCCESS_DISABLE_MFA_TOTP = 'Disabled TOTP Authentication successfully.';
export const ERROR_INVALID_CODE_MFA_TOTP = 'The code is invalid.';

export const SUCCESS_INVITE_USER = 'Invited user.';
export const ERROR_INVITE_USER = 'Invite user failed.';
export const SUCCESS_DECLINE_INVITE = 'Declined invite successfully.';
export const INSUFFICIENT_INVITE_PERMISSIONS = 'Higher permissions than your own.';
export const ERROR_INVITE_LINK = 'The invite is not exist or expired!';

export const SUCCESS_UPDATE_ROLES = 'Roles updated.';
export const SUCCESS_UPDATE_ROLE = 'Role updated.';
export const ERROR_UPDATE_ROLE = 'Role update failed.';
